import { useEffect, useState } from 'preact/hooks';
import { api, type Participant } from '../lib/api.js';
import { useLocation } from 'preact-iso';
import { CalendarDays, Plus, Inbox as InboxIcon, Settings as SettingsIcon } from 'lucide-preact';

export function BottomNav() {
  const { url } = useLocation();
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    api<Participant[]>('/api/v1/participants/pending')
      .then((rows) => setPendingCount(rows.length))
      .catch(() => setPendingCount(0));
  }, [url]);

  const is = (prefix: string) =>
    url === prefix || (prefix !== '/' && url.startsWith(prefix));

  return (
    <nav class="bottom-nav">
      <a href="/" class={is('/') && !is('/new') && !is('/inbox') && !is('/settings') && !is('/event') ? 'active' : ''}>
        <CalendarDays class="ico" size={22} />
        <span>Woche</span>
      </a>
      <a href="/new" class={is('/new') ? 'active' : ''}>
        <Plus class="ico" size={22} />
        <span>Neu</span>
      </a>
      <a href="/inbox" class={is('/inbox') ? 'active' : ''}>
        <InboxIcon class="ico" size={22} />
        <span>Inbox</span>
        {pendingCount > 0 ? <span class="badge">{pendingCount}</span> : null}
      </a>
      <a href="/settings" class={is('/settings') ? 'active' : ''}>
        <SettingsIcon class="ico" size={22} />
        <span>Mehr</span>
      </a>
    </nav>
  );
}
